import React from 'react';

import * as _ht from './_ht';
import * as _cr from './_cr';

import { a } from './_cmABT';

import * as BoxC from './_ccbBoxC';
import * as TextC from './_ccbTextC';

export type tLblCz = {
  abtz?: _ht.dz,
  boxStlz?: _ht.dz,
  lblCz?: TextC.tTextCz, // label
  cttCz?: BoxC.tBoxCz, // content
  omtCz?: TextC.tTextCz, // ornament
};

const $grtAbtz = (pz?: {
  type?: _ht.s,
  dw?: _ht.n,
  tc?: _ht.s,
  ts?: _ht.s,
  bMpl?: _ht.b, // multiple line
}) => {
  const _fd = pz?.bMpl ? 'rss' : 'rsc';
  const _pt = pz?.bMpl ? 0.5 : 0;
  const _dw = pz?.dw ?? 15;
  const _tc = pz?.tc ?? 'lt9';
  const _ts = pz?.ts ?? 'm';
  switch (pz?.type) {
    case 'hzl':
      return {
        boxStlz: a(`dw/f fd/${_fd} pr/1`),
        lblCz: {
          boxStlz: a(`dw/${_dw} pl/1 pr/0.5 pt/${_pt}`),
          textStlz: a(`tb tc/${_tc} ts/${_ts}`)
        },
        cttCz: {
          boxStlz: a('f/1 fd/rsc'),
        },
      };
    case 'vcl':
      return {
        boxStlz: a('dw/f fd/css'),
        lblCz: {
          boxStlz: a('dw/f fd/rsc'),
          textStlz: a(`tb tc/${_tc} ts/ ts/${_ts}`)
        },
        cttCz: {
          boxStlz: a('dw/f fd/rsc'),
        },
      };
    default:
      return {
        boxStlz: {},
        lblCz: {
          boxStlz: {},
          textStlz: {},
        },
        cttCz: {
          boxStlz: {},
        },
        omtCz: {
          boxStlz: {},
          textStlz: {},
        },
      };
  }
};

export const N = React.memo((pz: tLblCz) => {

  const _abtz = $grtAbtz(pz.abtz)

  return (
    _cr.c(BoxC.N, {
      key: -10,
      boxStlz: {
        ... _abtz?.boxStlz,
        ... pz.boxStlz,
      },
      boxClds: [

        (pz.lblCz) ?
        _cr.c(TextC.N, {
          key: -10,
          ... pz.lblCz,
          boxStlz: {
            ... _abtz?.lblCz?.boxStlz ?? {},
            ... pz.lblCz?.boxStlz,
          },
          textStlz: {
            ... _abtz?.lblCz?.textStlz,
            ... pz.lblCz?.textStlz,
          }
        })
        : null,

        (pz.cttCz) ?
        _cr.c(BoxC.N, { // main
          key: -20,
          ... pz.cttCz,
          boxStlz: {
            ... _abtz?.cttCz?.boxStlz,
            ... pz.cttCz?.boxStlz,
          },
        })
        : null,

        (pz.omtCz) ?
        _cr.c(TextC.N, { // main
          key: -30,
          ... pz.omtCz,
          boxStlz: {
            ... _abtz?.omtCz?.boxStlz,
            ... pz.omtCz?.boxStlz,
          },
          textStlz: {
            ... _abtz?.omtCz?.textStlz,
            ... pz.omtCz?.textStlz,
          }
        })
        : null,

      ]
    })
  );
});
